import { FormFieldConfig } from "Components/Common/CommonForm";
import { Column } from "Components/Common/CommonTableIndexWise";
import styles from "../css/transferVolunteerList.module.scss";
import { formatDate } from "common/service/CommonService";
import { Link } from "react-router-dom";
import { TRANSFER_VOLUNTEER_PATHS } from "Routes/paths";
import { validations } from "validations/FormValidations";

export const getSubjectFields = (): FormFieldConfig[] => [
  {
    name: "studycode",
    label: "Study Code",
    type: "text",
    required: true,
    disabled: true,
  },
  {
    name: "volunteerinitial",
    label: "Volunteer Initial",
    type: "text",
    required: true,
    disabled: true,
  },
];

export const getTransferFields = (
  studyOptions: { label: string; value: any }[],
  transferTypeOptions: { label: string; value: any }[]
): FormFieldConfig[] => [
    {
      name: "transfertype",
      label: "Transfer Type",
      type: "select",
      required: true,
      options: transferTypeOptions,
    },
    {
      name: "targetstudyid",
      label: "Destination Study Code",
      type: "select",
      required: true,
      options: studyOptions,
    },
    // {
    //   name: "transferdate",
    //   label: "Transfer Date",
    //   type: "date",
    //   required: true,
    // },
  ];

export const getEligibilityFields = (): FormFieldConfig[] => [
  {
    name: "rescreeningrequired",
    label: "Re-screening Required",
    type: "radio",
    required: true,
    options: [
      { label: "Yes", value: "Yes" },
      { label: "No", value: "No" },
    ],
  },
];

export const getReasonFields = (
  transferReasonOptions: { label: string; value: any }[]
): FormFieldConfig[] => [
    {
      name: "transferreason",
      label: "Transfer Reason",
      type: "select",
      required: true,
      options: transferReasonOptions,
    },
    {
      name: "remarks",
      label: "Detailed Remarks",
      type: "textarea",
      placeholder: "Enter detailed transfer remarks...",
      rules: validations.transfervolunteer.detailedremarks,
    },
  ];

export const transferVolunteerColumns: Column[] = [
  {
    key: "fromstudycode",
    label: "Study Code ",
    render: (_: any, row?: any) => {
      if (!row) return null;
      return (
        <>
          <Link
            to={
              TRANSFER_VOLUNTEER_PATHS.VIEW.replace(
                ":id",
                String(row?.volunteertransferid ?? row?.id ?? "")
              )
            }
            className="mb-0 fw-medium text-primary text-decoration-none d-block"
          >
            {row.fromstudycode || "—"}
          </Link>
          {/* <p className="mb-0 text-muted fs-12">
            {row.subjectno || "—"}
          </p> */}
        </>
      );
    },
  },
  {
    key: "initials",
    label: "Volunteer Initials",
  },
  {
    key: "tostudycode",
    label: "Destination Study",
  },
  {
    key: "transferdate",
    label: "Transfer Date",
    render: (value: any) => (value ? formatDate(value) : "—"),
  },
  {
    key: "rescreeningrequired",
    label: "Re-screening",
    render: (_: any, row?: any) => {
      if (!row) return null;
      const isRequired = row.isscreeningrequiredtext === "Yes";
      return (
        <span className={isRequired ? styles.badgePerm : styles.badgeTemp}>
          {row.isscreeningrequiredtext}
        </span>
      );
    },
  },
  {
    key: "remarks",
    label: "Remarks/Reason",
    tooltip: true,
    maxLength: 30
  },
  {
    key: "verifiedby",
    label: "Verified By",
    render: (_: any, row?: any) => {
      if (!row) return null;
      return (
        <>
          <p className="mb-0 fw-medium text-dark">{row.verifiedbytext || "—"}</p>
          <p className="mb-0 text-muted fs-12">
            {row.verifieddate ? formatDate(row.verifieddate) : "—"}
          </p>
        </>
      );
    },
  },
];
